export const personalDetails = {
  title: 'Personal Details',
  mapData: [
    { label: 'First Name', value: 'firstName' },
    { label: 'Last Name', value: 'lastName' },
    { label: 'Gender', value: 'gender' },
    { label: 'Date Of Birth', value: 'dob' },
    { label: 'Blood Group', value: 'bloodgroup' },
    { label: 'Email', value: 'email' },
    { label: "Father's Name", value: 'fatherName' },
    { label: "Father's Contact Number", value: 'fatherContactNumber' },
    { label: "Mother's Name", value: 'motherName' },
    { label: "Mother's Contact Number", value: 'motherContactNumber' },
    {
      label: 'Permanent Address',
      value: 'permanentAddress',
      fullWidth: true,
    },
  ],
};

export const academicDetails = {
  title: 'Academic Details',
  mapData: [
    { label: 'School', value: 'schoolName' },
    { label: 'Class', value: 'className' },
    { label: 'Syllabus', value: 'syllabusName' },
    { label: 'Medium', value: 'mediumName' },
  ],
};

export const courseDetails = {
  title: 'Course Details',
  mapData: [
    { label: 'Admission No.', value: 'admnNo' },
    { label: 'Course Enrolled', value: 'courseEnrolledDate' },
    // { label: "Date of Admission", value: "2023-05-20" }
  ],
};
